import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const DigitalHumansIndex = () => import('./Index.vue');
const DigitalHumanEdit = () => import('./Edit.vue');
const DigitalHumanTemplates = () => import('./Templates.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/digital-humans'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return {
              name: 'settings_digital_humans_list',
              params: to.params,
            };
          },
        },
        {
          path: 'list',
          name: 'settings_digital_humans_list',
          component: DigitalHumansIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'templates',
          name: 'settings_digital_humans_templates',
          component: DigitalHumanTemplates,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: ':digitalHumanId/edit',
          name: 'settings_digital_humans_edit',
          component: DigitalHumanEdit,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
